import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
});

export default class CoopPartnerModel extends Model.extend(Validations) {
  @attr('string') city;
  @attr('string') email;
  @attr('string') name;
  @attr('string') phone;
  @attr('string') street;
  @attr('string') zipcode;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('category', { async: true, inverse: null }) coopTypes;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }
}
